__turbopack_context__.v({
  "cover": "books-page-module__qku_uq__cover",
  "coverEmpty": "books-page-module__qku_uq__coverEmpty",
  "coverImage": "books-page-module__qku_uq__coverImage",
  "grid": "books-page-module__qku_uq__grid",
  "page": "books-page-module__qku_uq__page",
});
